import { useState } from 'react';
import Notification from '../components/toast/Notification'

function useNotification() {
  const [notification, setNotification] = useState(null);
  const [title, setTitle] = useState(null);
  const [type, setType] = useState(null);

  /**
   * Formats an array into a string with each element on a new line
   * @param {Array|*} message - The message to format
   * @returns {string} - The formatted message
   */
  const formatArrayToString = (message) => {
    if (Array.isArray(message)) {
      return message.join('\n');
    }
    return message;
  };

  const showNotification = (title = 'Missing Title', message = 'Missing Message', type = 'success') => { 
    setTitle(title);
    // Always set notification, even if message is an empty string
    const formattedMessage = formatArrayToString(message);
    setNotification(formattedMessage);
    setType(type);
  };

  const closeNotification = () => {
    setNotification(null)
    setTitle(null)
    setType(null)
  };

  const NotificationComponent = notification !== null && notification !== undefined && (
    <Notification message={notification} title={title} type={type} onClose={closeNotification} />
  );

  return {
    showNotification,
    NotificationComponent,
  };
}

export default useNotification;
